import VeeValidate, { Validator } from 'vee-validate'

Validator.extend('positive', {
    getMessage: field => 'The ' + field + ' value is not positive.',
    validate: value => {
        if(value === '' || value === undefined){
            return false;
        }
        let n = parseFloat((value + '').replace(',','.'));
        return n >= 0;
    }
});

Validator.extend('youtube', {
    getMessage: field => 'Поле "' + field + '" имеет не верный формат для ссылки Youtube',
    validate: value => {
        if(value === '' || value === undefined){
            return false;
        }
        let regExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        return (regExp).test(value);
        //return (/^https:\/\/(www\.)?youtube.com\/embed\/.*/ig).test(value);
    }
});

Validator.extend('percent', {
    getMessage: field => 'Поле "' + field + '" имеет не верное значение',
    validate: value => {
        if(value === '' || value === undefined){
            return false;
        }

        if(!(/^\-?\d{1,}(?:\.|\,)?\d{0,}$/ig).test(value)){
            return false;
        }

        let percentNumber = parseFloat(value);
        if(isNaN(percentNumber)){
            return false;
        }

        return Math.abs(percentNumber) <= 100;
    }
});

Validator.extend('bik', {
    getMessage: field => 'Поле "' + field + '" имеет не верный формат',
    validate: value => {
        if(value === '' || value === undefined){
            return false;
        }
        return (/^04\d{7}$/ig).test(value);
    }
});

Validator.extend('cs', {
    getMessage: field => 'Поле "' + field + '" имеет не верный формат',
    validate: (value, args) => {
        if(value === '' || value === undefined){
            return false;
        }
        if(!(/^\d{20}$/ig).test(value)){
            return false;
        }
        if(args.length && args[0]){
            let bikCs = '0' + args[0].slice(4, 6) + value;
            let checksum = 0;
            let coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];
            for (let i in coefficients) {
                checksum += coefficients[i] * (bikCs[i] % 10);
            }
            return checksum % 10 === 0;
        }else{
            return true;
        }
    }
});

Validator.extend('rs', {
    getMessage: field => 'Поле "' + field + '" имеет не верный формат',
    validate: (value, args) => {
        if(value === '' || value === undefined){
            return false;
        }
        if(!(/^\d{20}$/ig).test(value)){
            return false;
        }
        if(args.length && args[0]){
            let bikRs = args[0].slice(-3) + value;
            let checksum = 0;
            let coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];
            for (let i in coefficients) {
                checksum += coefficients[i] * (bikRs[i] % 10);
            }
            //console.info('checksum', checksum);
            return checksum % 10 === 0;
        }else{
            return true;
        }
    }
});

Validator.extend('jsonArray', {
    getMessage: field => 'Поле "' + field + '" имеет не верный формат для типа Список',
    validate: value => {
        if (value === '' || value === undefined) {
            return false;
        }
        try {
            let obj = JSON.parse(value);
            if (Array.isArray(obj) && obj.length > 0 && typeof obj[0] === 'string') {
                return true;
            }
        } catch (e) {
            //console.info('valid jsonArray er: ', e);
        }
        return false;
    }
});

Validator.extend('lonlat', {
    getMessage: field => 'Поле "' + field + '" имеет не верный формат',
    validate: value => {
        if (value === '' || value === undefined) {
            return false;
        }
        var regExp = /^-?([1][0-8][0-9]|[1-9][0-9]?)[.|,]\d{1,6}$/ig;
        return (regExp).test(value);
    }
});

Validator.extend('passportSeries', {
    getMessage: field => 'Серия паспорта должна состоять из 4 цифр',
    validate: (value, args) => {
        if (value === '' || value === undefined) {
            return false;
        }
        if(args.length > 0 && args[0] === 2) {
            return (/^\d{2}$/ig).test(value);
        } else {
            return (/^\d{4}$/ig).test(value);
        }
    }
});

Validator.extend('passportNumber', {
    getMessage: field => 'Номер паспорта должен состоять из 6 цифр',
    validate: (value, args) => {
        if (value === '' || value === undefined) {
            return false;
        }
        if(args.length > 0 && args[0] === 7) {
            return (/^\d{7}$/ig).test(value);
        } else {
            return (/^\d{6}$/ig).test(value);
        }
    }
});

Validator.extend('innfl', {
    getMessage: field => 'ИНН физического лица должен состоять из 12 цифр',
    validate: value => {
        if (value === '' || value === undefined) {
            return false;
        }
        var regExp = /^\d{12}$/ig;
        return (regExp).test(value);
    }
});



// WEBPACK FOOTER //
// ./Content/src/helpers/custom-validators.js